export default "__VITE_ASSET__f7u0Gx18__"